/**
 * @description: 我的寄件地址
 * @author: 51fan
 */
<template>
  <div class="addressManageContent main-wrap">
       <div class="main-top">
            <el-button type="primary" class="addAddress h40" @click="rowAdd" icon="iconfont iconxinzeng">{{$lang('新增寄件地址')}}</el-button>
            <div class="searchParam">
                <div class="searchParamInput">
                    <el-input v-model="searchParam" :placeholder="$lang('姓名/联系电话/地址')" style="width:336px !important"></el-input>
                </div>
                <el-button type="primary"  @click="searchChange" icon="iconfont iconchaxun" class="h32 search">{{$lang("查询")}}</el-button>
                <el-button type="primary"  @click="resetSearch" plain icon="iconfont iconshanchu" class="h32">{{$lang("清空")}}</el-button>
                <!--<el-button type="primary" class="addAddress" @click="rowAdd"><i class="iconfont iconxinzeng"></i> 新增寄件地址</el-button> -->
            </div>
       </div>
       <div class="main-table">
            <JmsTableScroll
            :option="listOpt"
            :data="tableList"
            :page="page"
            :table-loading="loading"
            @row-edit="rowEdit"
            @row-del="rowDel"
            @size-change="sizeChange"
            @select-change="selectionChange"
            @current-change="currentChange">
              <template slot="isDefault" slot-scope="data">
                    <el-switch
                                v-model="data.row.isDefault"
                                active-color="#13ce66"
                                inactive-color="#dcdfe6"
                                :active-value="1"
                                :inactive-value="2"
                                disabled>
                    </el-switch>
                </template>
            </JmsTableScroll>
       </div>
    <!-- 编辑地址 -->
    <el-dialog :title="diglogTitle" :visible.sync="editDialogVisible" width="1020px" @close="handleClose" :modal-append-to-body="false"
      :close-on-click-modal="false">
      <el-form class="el-form-edit" ref="tableForm"  :rules="rules" :inline="true" :model="rowData" label-position="left" label-suffix=" :">
        <!-- <el-form-item label="地址识别" class="item-col-4">
          <el-input v-model="analysisAddress" :autosize="{minRows: 5 }"  type="textarea" placeholder="粘贴或者输入整段地址，点击“识别”自动拆分姓名、电话和地址。例如：李小兔，13800138000，上海市黄浦区某某大厦…">
          </el-input>
          <div class="oper">
            <span class="red" @click="discern(0)">智能识别</span>
            <span @click="discern(1)">清空</span>
          </div>
        </el-form-item> -->
        <el-form-item :label="$lang('姓名')" prop="name" class="myDetailItem">
          <el-input v-model="rowData.name"  :minlength="1"  :maxlength="30"  :placeholder="$lang('请填写寄件人姓名')"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('联系电话')" prop="mobile"  class="myDetailItem">
          <el-input v-model="rowData.mobile" :minlength="10" :maxlength='13' :placeholder="$lang('请填写寄件人联系电话')"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('公司名称')" prop="companyName" class="myDetailItem">
          <el-input v-model="rowData.companyName" :placeholder="$lang('请填写寄件人公司名称')" :maxlength="30"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('省/市/区')" prop="province" class="myDetailItem">
          <BaseAddress ref="provinceSearch" :initAddressData="initAddressData" :showLevel="3" @changeValue="senderchangeValue" v-model="rowData.province"> </BaseAddress>
        </el-form-item>
        <el-form-item class="el-form-item el-form-item--small" :label="$lang('邮编')" prop="postalCode">
          <el-input v-model="rowData.zipcode" :placeholder="$lang('请输入邮编')" :maxlength="5" @input="changeAddress($event)"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('详细地址')" prop="detailedAddress" class="addressDeatil">
          <el-input v-model="rowData.detailedAddress" :placeholder="$lang('请填写寄件人所在街道以及详细地址')"  :minlength="1"  :maxlength="150"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('设为默认')" prop="isDefault">
          <el-switch v-model="rowData.isDefault" active-color="#13ce66" inactive-color="#ddd"> </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="handleClose('tableForm')">取 消</el-button> -->
        <el-button type="primary" :loading="keyBtn" @click="handleSubmit('tableForm')" class="h40 h104">{{$lang('保存')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants'
// import JmsTableScroll from '@/components/jms-widget/jms-table'
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin'
import { addAddress, reqAddressList, updateAddress, delAddress, queryAddressAnalysisAddress } from '@api/module/customer'
import { RULES, phoneAndMobile, checkAddressFormat } from '@utils/rules'
import * as Api from '@api/base/public'

export default {
  name: 'MailingAddress',
  components: {
    JmsTableScroll,
  },
  mixins: [mixin],
  data() {
    return {
      COM_HTTP: {
        reqList: reqAddressList,
        reqAdd: addAddress,
        reqUpdate: updateAddress,
        reqDel: delAddress,
      },
      diglogTitle: this.$lang('新增寄件地址'),
      analysisAddress: '',
      searchParam: '',
      rowData: {
        name: '',
        mobile: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        townshipId: '',
        townshipName: '',
        zipcode: '',
        detailedAddress: '',
        isDefault: false, // 是否设置为默认地址 1设置默认地址 2 不设置
        type: 1, // 1 寄件 2收件
        id: '',
      },
      initAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
          townIdProp: 'townshipId',
          townNameProp: 'townshipName',
          zipcodeProp: 'zipcode',
        },
        defaultData: {},
      },
      tableList: [],
      isRowDetailUrl: false,
      rules: {
        name: [RULES.requiredTrim],
        mobile: [RULES.requiredTrim, { validator: phoneAndMobile }, RULES.lengthTenThirdteen],
        province: [RULES.requiredSelect],
        detailedAddress: [RULES.requiredTrim, { validator: checkAddressFormat }],
      },
      delTitObj: {
        title: this.$lang('删除寄件地址'),
        subTitle: this.$lang('你确定要删除该寄件地址吗？'),
        threeTitle: '',
      },
    }
  },
  computed: {
    listOpt() {
      return {
        fixHeight: 90,
        border: true,
        selection: false,
        menu: true,
        menuWidth: 150,
        rowKey: '$index',
        viewBtn: false,
        column: [
          {
            label: '姓名',
            prop: 'name',
          },
          {
            label: '联系电话', //  扫描员
            prop: 'mobile',
          },
          {
            label: '省份',
            prop: 'provinceName',
          },
          {
            label: '城市',
            prop: 'cityName',
          },
          {
            label: '区域',
            prop: 'areaName',
          },
          // {
          //   label: '乡镇',
          //   prop: 'townshipName',
          // },
          {
            label: '邮编',
            prop: 'zipcode',
          },
          {
            label: '公司名称',
            prop: 'companyName',
          },
          {
            label: '详细',
            prop: 'detailedAddress',
          },
          {
            label: '是否默认',
            prop: 'isDefault',
            slot: true,
            // formatter: (row, value, label, column) => {
            //   const map = {
            //     1: '<i class="dot green" style="color: #00da00;"></i> ' + '是',
            //     2: '<i class="dot oragin" style="color: #ffa111"></i> ' + '否',
            //   }
            //   return map[row.isDefault]
            // },
          },
        ],
      }
    },
  },
  methods: {
    senderchangeValue(data) {
      if (data && data.zipcode) {
        this.rowData.zipcode = data.zipcode
      }
    },
    // 通过邮编改变省市区
    async changeAddress(zipCode) {
      if (zipCode.length !== 5 && zipCode.length !== 0) return
      const { code, msg, data } = await Api.GET_QUERY_AREA({ current: 1, size: 9999, zipcode: zipCode })
      if (code === RESPONSE_SUCCESS) {
        const records = data.filter(item => item.type === 4 || item.type === 5)
        if (records.length > 0) {
          this.$refs.provinceSearch.selectSearchClick(records[0])
        }
      } else {
        this.$message.warning(msg)
      }
    },
    discern(type) {
      let text
      switch (type) {
        case 0:
          console.log(1, { ...this.rowData })
          if (!this.analysisAddress) { return }
          text = this.analysisAddress
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then(res => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  name: person,
                  mobile: phonenum,
                  detailedAddress: detail,
                  provinceName: province,
                  provinceId: provinceCode,
                  cityId: cityCode,
                  cityName: city,
                  areaId: countyCode,
                  areaName: county,
                  province: {
                    provinceName: province,
                    provinceId: provinceCode,
                    cityId: cityCode,
                    cityName: city,
                    areaId: countyCode,
                    areaName: county,
                  },
                }
                this.rowData = Object.assign(this.rowData, obj)
                console.log(2, { ...this.rowData })
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 1:
          this.analysisAddress = ''
          break
        default:
          break
      }
    },
    getParams() {
      return {
        type: 1,
        keyword: this.searchParam,
      }
    },
    // 表单保存前
    beforeSubmit() {
      const isDefault = this.rowData.isDefault ? 1 : 2
      // const params = {
      //   name: this.rowData.name.trim(),
      // }
      return { ...this.rowData, isDefault, ...this.rowData.province, zipcode: this.rowData.zipcode }
    },
    // 弹窗关闭前
    beforehandleClose() {
      this.diglogTitle = this.$lang('新增寄件地址')
    },
    // 重新处理字段不一的查看字段
    handleData(row) {
      this.diglogTitle = this.$lang('编辑地址')
      const { provinceId, provinceName, cityId, cityName, areaId, areaName, townshipId, townshipName, isDefault } = row
      const defaultData = { provinceId, provinceName, cityId, cityName, areaId, areaName, townshipId, townshipName }
      this.$nextTick(function () {
        this.$set(this.initAddressData, 'defaultData', defaultData)
      })
      return { ...row, isDefault: isDefault === 1, type: 1, province: defaultData }
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = ''
    },
    // 重置表单项
    clearFormItem () {
      this.rowData = {
        name: '',
        mobile: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        townshipId: '',
        townshipName: '',
        zipcode: '',
        detailedAddress: '',
        isDefault: false,
        type: 1,
        id: '',
      }
      this.initAddressData.defaultData.provinceId = ''
      this.initAddressData.defaultData.provinceName = ''
      this.initAddressData.defaultData.cityId = ''
      this.initAddressData.defaultData.cityName = ''
      this.initAddressData.defaultData.areaId = ''
      this.initAddressData.defaultData.areaName = ''
      this.initAddressData.defaultData.townshipId = ''
      this.initAddressData.defaultData.townshipName = ''
      this.$refs.provinceSearch.clearInput()
      this.$refs['tableForm'].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
.addressManageContent {
  .main-top{
       padding:16px 24px;
  }
  .main-table{
     padding: 12px 24px;
    background: #edeef3;
    flex: 1;
        display: flex;
        flex-direction: column;
  }
  .searchParam {
    display: inline-flex;
    width: 100%;
    position: relative;
    margin-top: 10px;
    .searchParamInput {
      padding-right: 16px;
    }
    .el-button {
      height: 32px;
    }
    .addAddress {
      position: absolute;
      right: 0;
      height: 32px;
    }
  }
  .dot.oragin::before {
    width: 8px;
    height: 8px;
    background: #e60012;
  }
  /*.dot.green::before {*/
  /*  background: #52C41A;*/
  /*}*/
  .el-dialog {
    .el-dialog__body {
      .myDetail {
        display: inline-flex;
        padding: 0 0 24px 0;
        .myDetailItem {
          width: 200px;
          padding: 0 8px;
          .myDetailItemText {
            padding-bottom: 4px;
          }
        }
      }
      .addressDeatil {
        .el-input{
             width: 360px !important;
        }
      }
    }
    .reuqire {
      color: red;
    }
    .el-dialog__header {
      padding: 12px 25px !important;
      border-bottom: 1px solid #eeeeee;
    }
  }
}
.oper{
  position: absolute;
  right: 20px;
  bottom: 5px;
  cursor: pointer;
  color: #333;
  .red{
    color: red;
    margin-right: 20px;
  }
}
</style>
<style lang="scss">
.addressManageContent{
    .el-table__fixed, .el-table__fixed-right{
        height: 705px !important;
    }
}
</style>
